import { useId } from "react";
import { INVOICE_ITEM_DESCRIPTION_MAX_LENGTH } from "../../ProductService/BonificoOrder/invoiceItemDescription.ts";

export function InvoiceItemDescriptionInput({
  value,
  placeholder,
  onChange,
}: {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
}) {
  const inputId = useId();
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={inputId} className="text-sm font-medium text-gray-700">
        Descrizione in fattura
      </label>
      <input
        id={inputId}
        type="text"
        value={value}
        placeholder={placeholder}
        maxLength={INVOICE_ITEM_DESCRIPTION_MAX_LENGTH}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:border-primary focus:outline-none"
      />
      <span className="self-end text-xs text-gray-400">
        {value.length}/{INVOICE_ITEM_DESCRIPTION_MAX_LENGTH}
      </span>
    </div>
  );
}
